























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ManualModel } from "../models";
import { capitalize } from "../filters/capitalize";
import { getNonCachedBlob } from "../api";

@Component({
  filters: { capitalize },
})
export default class ManualBlock extends Vue {
  @Prop({ required: true })
  manual!: ManualModel;

  @Prop({ default: false })
  editMode!: boolean;

  thumbnailSrc = ``;

  @Watch(`manual`, { immediate: true })
  onManualChange(): void {
    this.loadThumbnailSrc();
  }

  private editManual() {
    this.$emit("openManualDialog", this.manual, false);
  }

  private removeManual() {
    this.$emit("openRemoveManualDialog", this.manual);
  }

  async loadThumbnailSrc(): Promise<void> {
    if (this.manual.thumbnail === "") return;
    try {
      const blob = await getNonCachedBlob(this.manual.thumbnail);
      var reader = new FileReader();
      reader.onload = () => {
        this.thumbnailSrc = reader.result as string;
      };
      reader.readAsDataURL(blob);
    } catch (e) {
      // silently fail
    }
  }
}
